import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, first } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { ShowcaseLayoutModel } from "src/app/shared/models/showcase-layout.model";

@Injectable({
  providedIn: "root",
})
export class EntityService {
  constructor(private http: HttpClient) {}

  getEntityUser() {
    return this.http
      .get<any>(`${environment.apiUrl}/entities/entity-user`, {
        withCredentials: true,
      })
      .pipe(first());
  }

  getStorage() {
    return this.http
      .get<any>(`${environment.apiUrl}/subscriptions-plans/storage`, {
        withCredentials: true,
      })
      .pipe(first());
  }

  updateEntityUser(data: any) {
    return this.http
      .patch<any>(`${environment.apiUrl}/entities/update/entity-user`, data, {
        withCredentials: true,
      })
      .pipe(first());
  }

  changeSubscription(data: any) {
    return this.http
      .patch<any>(
        `${environment.apiUrl}/entities/change/entity-subscription`,
        data,
        { withCredentials: true },
      )
      .pipe(first());
  }

  getSubscritpionsPlans(contryId: number) {
    return this.http
      .get<
        []
      >(`${environment.apiUrl}/subscriptions-plans/country/${contryId}`, { withCredentials: true })
      .pipe(
        first(),
        catchError((error) => {
          return [];
        }),
      );
  }

  updatePaymentconfirmed(data: any) {
    return this.http
      .patch<any>(
        `${environment.apiUrl}/entities/update/entity-subscription-confirmed`,
        data,
        { withCredentials: true },
      )
      .pipe(first());
  }

  updateSubscriptionAdditionalUsers(data: any) {
    return this.http
      .patch<any>(
        `${environment.apiUrl}/entities/update/entity-subscription-additional-users`,
        data,
        { withCredentials: true },
      )
      .pipe(first());
  }

  updateSubscriptionRenew(data: any) {
    return this.http
      .patch<any>(
        `${environment.apiUrl}/entities/update/entity-subscription-renew`,
        data,
        { withCredentials: true },
      )
      .pipe(first());
  }

  previewEntityWatermark(formData: any) {
    return this.http.post(
      `${environment.apiUrl}/entities/preview-entity-watermark`,
      formData,
      { responseType: "blob", withCredentials: true },
    );
  }

  previewStoreWatermark(formData: any) {
    return this.http.post(
      `${environment.apiUrl}/entities/preview-store-watermark`,
      formData,
      { responseType: "blob", withCredentials: true },
    );
  }

  // previewStoreImage(formData: any) {
  //   return this.http.post(
  //     `${environment.apiUrl}/entities/preview-background-store`,
  //     formData,
  //     { responseType: "blob", withCredentials: true }
  //   );
  // }

  getEntityForProposal() {
    return this.http
      .get<any>(`${environment.apiUrl}/entities/entity-proposal`, {
        withCredentials: true,
      })
      .pipe(first());
  }

  getShowcaseLayouts() {
    return this.http
      .get<ShowcaseLayoutModel[]>(`${environment.apiUrl}/showcase-sheet/layouts`, {
        withCredentials: true,
      })
      .pipe(first());
  }

  getPropertyValidationRules() {
    return this.http
      .get<any>(`${environment.apiUrl}/entities/property-validation-rules`, {
        withCredentials: true,
      })
      .pipe(first());
  }

  savePropertyValidationRules(data: {
    propertyValidationRules: boolean;
    rules: Array<{
      fieldId: number;
      enabled: boolean;
      valueMin?: number | null;
    }>;
  }) {
    return this.http
      .post<any>(
        `${environment.apiUrl}/entities/create-property-validation-rules`,
        data,
        {
          withCredentials: true,
        },
      )
      .pipe(first());
  }
}
